import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useHost } from '@xing-com/crate-xinglet';
// eslint-disable-next-line no-restricted-imports
import type { TopBarProps } from '@xing-com/top-bar';

// eslint-disable-next-line no-restricted-imports
export { ActionSlot } from '@xing-com/top-bar';

type CrateTopBarProps = {
  hideLoggedOut?: boolean;
  subHeaderContent?: React.ReactNode;
  isSticky?: boolean;
  isLoggedOut?: boolean;
} & TopBarProps;

export const TopBar: React.FC<CrateTopBarProps> = ({
  hideLoggedOut,
  ...props
}) => {
  const { isLoggedOut } = useLoginState();
  const { XingletLoader } = useHost();

  return isLoggedOut && hideLoggedOut ? null : (
    <XingletLoader name="@xing-com/crate-communication-root" topBar={props} />
  );
};
